import type { ReactNode } from "react";
import { t } from "ttag";

import { usePageTitle } from "metabase/hooks/use-page-title";

import DeprecationNotice from "../../containers/DeprecationNotice";

export interface AdminAppProps {
  children?: ReactNode;
}

const AdminApp = ({ children }: AdminAppProps): JSX.Element => {
  // A fractional index, not 0: ties with the app-level title (also idx 0,
  // set in AppComponent) resolve by React effect mount order, which fires
  // this nested component's effect *before* the app shell's — putting
  // "Admin" on the wrong side of "Metabase". A distinct value between the
  // app title (0) and every leaf page's title (1) makes the order
  // deterministic regardless of mount timing.
  usePageTitle(t`Admin`, { titleIndex: 0.25 });

  return (
    <>
      <DeprecationNotice />
      {children}
    </>
  );
};

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default AdminApp;
